import React, { ReactElement } from 'react';
import { IconProps } from '../../../../types';

const DevMenuIcon = ({ className = 'w-6 h-6' }: IconProps): ReactElement => (
  <img
    className={className}
    src="/logos/bruh.png"
    alt="Dev Menu Icon"
  />
);

export default DevMenuIcon;
